import React, {Component} from 'react';
import '../styles/job-list/index';

class JobEmployerBranding extends Component {
    render() {
        return (
            // <div className="careerfy-main-section careerfy-parallex-full">
            //     <div className="container">
            //         <div className="row">
            //         <aside className="col-xl-6 careerfy-typo-wrap"> 
            //                 <div className="careerfy-right">
            //                     <img src="/images/devstack_logo.png" alt="" />
            //                 </div>
            //             </aside>
            //             <aside className="col-xl-6 careerfy-typo-wrap">
            //                 <div id="slickSlider" className="careerfy-testimonial-slider">
            //                     <div className="careerfy-testimonial-slide-layer">
            //                         <div className="careerfy-testimonial-wrap">
            //                             <p>I just got a job that I applied for via JobSearch! I used the site all the time during my job hunt.</p>
            //                             <div className="careerfy-testimonial-text">
            //                                 <h2>Richard Anderson</h2>
            //                                 <span>Nevada, USA</span>
            //                             </div>
            //                         </div>
            //                     </div>
            //                     <div className="careerfy-testimonial-slide-layer">
            //                         <div className="careerfy-testimonial-wrap">
            //                             <p>I just got a job that I applied for via JobSearch! I used the site all the time during my job hunt.</p>
            //                             <div className="careerfy-testimonial-text">
            //                                 <h2>Richard Anderson</h2>
            //                                 <span>Nevada, USA</span>
            //                             </div>
            //                         </div>
            //                     </div>
            //                 </div>
            //             </aside>
            //         </div>
            //     </div>
            // </div>

            <div className="careerfy-main-section careerfy-testimonial-full">
                <div className="container-fluid">
                    <div className="row">
                        <aside className="col-xl-6 careerfy-typo-wrap"> 
                            <div className="careerfy-right">
                                <img src="/images/devstack_logo.png" alt="" />
                            </div>
                        </aside>
                        <aside className="col-xl-6 careerfy-typo-wrap">
                            <div id="slickSlider" className="careerfy-testimonial-slider">
                                <div className="careerfy-testimonial-slide-layer">
                                    <div className="careerfy-testimonial-wrap">
                                        <p>I just got a job that I applied for via JobSearch! I used the site all the time during my job hunt.</p>
                                        <div className="careerfy-testimonial-text">
                                            <h2>Richard Anderson</h2>
                                            <span>Nevada, USA</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="careerfy-testimonial-slide-layer">
                                    <div className="careerfy-testimonial-wrap">
                                        <p>I just got a job that I applied for via JobSearch! I used the site all the time during my job hunt.</p>
                                        <div className="careerfy-testimonial-text">
                                            <h2>Richard Anderson</h2>
                                            <span>Nevada, USA</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        )
    }
};

export default JobEmployerBranding;


// WEBPACK FOOTER //
// ./src/components/JobEmployerBranding.js